var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-table',{attrs:{"showDelete":false,"showEdit":false,"tableData":_vm.spreadSheets,"tableTitle":"Tariffs","fields":_vm.headers}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"pull-right"},[_c('parse-from-json',{attrs:{"disabled":false,"json":_vm.spreadSheets,"fileName":'Rates'}})],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-104abf72","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/rateassist/components/Results.vue
// module id = 2202
// module chunks = 1